import { driver_rankingService } from '../_services';

const state = { onRequest: false, driver_ranking: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        driver_rankingService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  driver_ranking: state => {
    return state.driver_ranking
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.driver_ranking = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.driver_ranking = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.driver_ranking = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const driver_rankings = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
